import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const progressBar = css`
  background: var(${themeVariables.colors.surface.brand});
  border-radius: 0.25rem;
  display: block;
  height: 0.5rem;
  margin: 0 auto 1.25rem;
  width: 11.25rem;
`;

export const progress = css`
  height: 100%;
  background: var(${themeVariables.colors.content.brand});
  border-radius: 0.25rem;
`;
